<template>
  <div>
    <v-stepper>
      <v-stepper-header v-model="e1">
        <v-stepper-step step="1">
          Inscription
        </v-stepper-step>

        <v-divider />

        <v-stepper-step step="2">
          Ajouter ses classes
        </v-stepper-step>

        <v-divider />

        <v-stepper-step step="3">
          Ad templates
        </v-stepper-step>
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content step="1">
          <inscription @move="move" />
        </v-stepper-content>

        <v-stepper-content step="2" />

        <v-stepper-content step="3" />
      </v-stepper-items>
    </v-stepper>

    <v-card>
      <h3>Bienvenue</h3>
      <p>
        Bienvenue sur la nouvelle plateforme Artifex du Calame d'Or. A partir de cette année, ce compte vous permettra de participer
      </p>
      <p />
    </v-card>

    <div class="d-flex justify-center my-6">
      <v-btn
        color="primary"
        @click="goNext"
      >
        Participer à l'édition {{ }}
      </v-btn>
    </div>
  </div>
</template>

<script>
  export default {
    methods: {
      goNext () {
        this.$emit('move', 'next')
      },
    },
  }
</script>
